export default {
  methods: {
    /**
     * @description 字符串不能为空时使用
     */
    $isRequired (rule, value, callback) {
      if (!value) {
        callback(new Error(rule.message))
        return
      }
      if (typeof value === 'string') {
        value = value.trim()
        if (!value) {
          callback(new Error(rule.message))
        } else {
          callback()
        }
      } else {
        callback()
      }
    },
    $isChinese (rule, value, callback, prop) { // 检测是否为中文
      if (!/^[A-Za-z\u4e00-\u9fa5]+$/.test(value)) {
        callback(new Error(`${prop}只能由中文或英文组成`))
      } else {
        callback()
      }
    },
    $isMobile (rule, value, callback) {
      if (/^1\d{10}$/.test(value)) {
        callback()
      } else {
        callback('手机号码格式有误')
      }
    },
    $isEmail (rule, value, callback) {
      if (/^\w+@\w+(\.\w+)+$/.test(value)) callback()
      else callback('电子邮箱格式有误')
    },
    $isNumberOrAlphabet (rule, value, callback, prop) {
      if (/^[a-zA-Z\d]+$/.test(value)) callback()
      else callback(new Error(`${prop ? prop : ''}只能是阿拉伯数字或英文字母`))
    },
    // 敏感词
  }
}



// WEBPACK FOOTER //
// ./src/mixins/validator.js